<template>
  <svg :width="`calc(14 / 12 * ${size})`" :height="size" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.318604 1.3125C0.318604 1.09701 0.405029 0.890349 0.558868 0.737976C0.712706 0.585603 0.921356 0.5 1.13892 0.5H12.6233C12.8409 0.5 13.0495 0.585603 13.2033 0.737976C13.3572 0.890349 13.4436 1.09701 13.4436 1.3125C13.4436 1.52799 13.3572 1.73465 13.2033 1.88702C13.0495 2.0394 12.8409 2.125 12.6233 2.125H1.13892C0.921356 2.125 0.712706 2.0394 0.558868 1.88702C0.405029 1.73465 0.318604 1.52799 0.318604 1.3125ZM0.318604 6.1875C0.318604 5.97201 0.405029 5.76535 0.558868 5.61298C0.712706 5.4606 0.921356 5.375 1.13892 5.375H12.6233C12.8409 5.375 13.0495 5.4606 13.2033 5.61298C13.3572 5.76535 13.4436 5.97201 13.4436 6.1875C13.4436 6.40299 13.3572 6.60965 13.2033 6.76202C13.0495 6.9144 12.8409 7 12.6233 7H1.13892C0.921356 7 0.712706 6.9144 0.558868 6.76202C0.405029 6.60965 0.318604 6.40299 0.318604 6.1875ZM1.13892 10.25C0.921356 10.25 0.712706 10.3356 0.558868 10.488C0.405029 10.6403 0.318604 10.847 0.318604 11.0625C0.318604 11.278 0.405029 11.4847 0.558868 11.637C0.712706 11.7894 0.921356 11.875 1.13892 11.875H12.6233C12.8409 11.875 13.0495 11.7894 13.2033 11.637C13.3572 11.4847 13.4436 11.278 13.4436 11.0625C13.4436 10.847 13.3572 10.6403 13.2033 10.488C13.0495 10.3356 12.8409 10.25 12.6233 10.25H1.13892Z" :fill="color"/>
  </svg>
</template>


<script>
export default {
  name: 'IconBurgerMenu',

  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
    size: {
      type: String,
      default: '1em',
    },
  },
};
</script>